module.exports = __webpack_public_path__ + "static/media/NZLogo.5a3e507a.svg";